import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ResearchService } from '../research.service';
import { of } from 'rxjs';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-research-screen-question',
  templateUrl: './research-screen-question.component.html',
  styleUrls: ['./research-screen-question.component.scss']
})
export class ResearchScreenQuestionComponent implements OnInit {

  constructor(
    private router: Router,
    public matDialog: MatDialog,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private researchService: ResearchService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  choice;
  consentForm: FormGroup;
  researchID;
  screenDetail;
  screenChoice

  ngOnInit(): void {

    this.researchID = new URL(location.href).searchParams.get('research_id');

    this.researchService.getDetailSceenQuestionResearchById(this.researchID).pipe(
      map(res => {
        if (res.success) {

          if (!res.result[0].PROGRESS.status_consent) {
            window.open('/research/research-consent?research_id=' + this.researchID + '&INVITER=' + '', '_self');

          } else if (!res.result[0].PROGRESS.status_sceen) {
            this.screenDetail = res.result[0];
            this.screenChoice = this.screenDetail.SCEENQUESTION;
            // // console.log(this.screenDetail);
            this.gobalFunctionService.setTitle(this.screenDetail.RESEARCH_NAME);
          } else {
            window.open('/research/research-detail?research_id=' + this.researchID, '_self');
          }


        }
      }),
      catchError((err) => {
        alert(err.error.message);
        return of(null)
      })
    ).subscribe();

    this.consentForm = this.fb.group({
      RESEARCH_ID: [this.researchID],
      DATA: this.fb.array([]),
    })
  }

  send(form) {
    let sendedAnswer = {};
    let data = []

    this.screenChoice.forEach((e, i) => {
      // // console.log(e)
      data.push({
        type: e.type,
        question: e.question,
        choices: e.type === 'choices' || e.type === 'checkbox' ? [e.choices] : [],
        answer: form.DATA[i].answer,
      })
    });

    sendedAnswer = {
      RESEARCH_ID: form.RESEARCH_ID,
      DATA: JSON.stringify(data)
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '350px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: 'ส่งคำตอบ',
      description: `<p class="title text-center">คุณต้องการจะส่งคำตอบใช่หรือไม่</p>`,
      actionBtnText: 'ยืนยัน',
      cancleBtnText: 'ยกเลิก',
      customStyle: 'background-color: #3E8C1A'
    }
    // // console.log(form);
    // // console.log(sendedAnswer);

    const confirmModal = this.matDialog.open(ModalComponent, dialogConfig);
    confirmModal.afterClosed().pipe(
      switchMap(res => {
        if (res) {
          return this.researchService.sendAnswerSceenQuestion(sendedAnswer).pipe(
            switchMap(res => {
              if (res) {
                const dialogConfig2 = new MatDialogConfig();
                dialogConfig2.disableClose = true;
                dialogConfig2.id = 'modalConfirm';
                dialogConfig2.width = '350px';
                dialogConfig2.data = {
                  title: 'ส่งคำตอบ',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">ส่งคำตอบสำเร็จ`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal = this.matDialog.open(ModalComponent, dialogConfig2);
                return modal.afterClosed().pipe(
                  map(res => {
                    window.open('/research/research-detail?research_id=' + this.researchID, '_self');

                  })
                )
              }
            })
          )

        } else {
          return of(null);
        }
      }),
      catchError((err => {
        alert(err.error.message);
        this.router.navigate(['/']);
        return of(null);
      }))
    ).subscribe();
  }

}
